import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import Image from 'next/image';
import { IconButton } from '@material-ui/core';
import clsx from 'clsx';

import { openModal } from 'features/utilsSlice';
import { postRequest } from 'utils/api';
import ConfirmationDialog from './ConfirmationDialog';
import styles from 'styles/components/Notification.module.scss';

const DuplicateAlert = ({ gigId, dismissAlert }) => {
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const dispatch = useDispatch();
  const router = useRouter();

  const handleDuplicate = () => {
    postRequest({
      endpoint: `gigs/${gigId}/duplicate`,
      successMessage: 'Successfully duplicated this gig! You can find it on your gig drafts page.',
    })
      .then(response => {
        dismissAlert();
        router.push(`/gigs/${response.data}/edit`);
      })
      .catch(() => {});
  };

  return (
    <>
      <div
        className={clsx(styles.notification, styles.hover)}
        onClick={() => {
          dispatch(openModal({ name: 'Confirmation', data: { action: 'approve' } }));
          setOpenConfirmation(true);
        }}
      >
        <span className={styles.icon}>
          <Image src="/icons/clone.svg" alt="image" width={22} height={22} unoptimized />
        </span>

        <div className={styles.text}>
          <p>Click here to duplicate your last gig to find additional influencers</p>
        </div>

        <IconButton className={styles.close} onClick={dismissAlert}>
          <Image src="/icons/close-main.svg" alt="close" width={12} height={12} unoptimized />
        </IconButton>
      </div>

      {openConfirmation && (
        <ConfirmationDialog
          title="Are you sure you want to duplicate this gig?"
          handleApprove={handleDuplicate}
        />
      )}
    </>
  );
};

export default DuplicateAlert;
